// Metadata for the ecommerce/booking storefront templates, used by both the
// admin TemplatePicker (settings) and the storefront dispatchers.
export const STORE_TEMPLATES = [
  {
    value: 'default',
    label: 'Default - Clean Grid',
    hint: 'Split hero, category chips and a product grid - works for any catalog',
    preview: { background: '#fff', accent: '#3B82F6', card: '#f1f5f9' },
  },
  {
    value: 'minimal',
    label: 'Minimal - Editorial Lookbook',
    hint: 'Full-bleed hero, one featured piece, big photos in a magazine layout',
    preview: { background: '#fafafa', accent: '#111827', card: '#e5e7eb' },
  },
  {
    value: 'bold',
    label: 'Bold - Streetwear Drop',
    hint: 'Dark stage, scrolling marquee, sidebar filters, dense numbered grid',
    preview: { background: '#0a0a0a', accent: '#bef264', card: '#171717' },
  },
  {
    value: 'vibrant',
    label: 'Vibrant - Playful Shelves',
    hint: 'Category bubbles and a sliding row of colorful cards per category',
    preview: { background: '#fdf2f8', accent: '#ec4899', card: '#fce7f3' },
  },
];

export const BOOKING_TEMPLATES = [
  {
    value: 'default',
    label: 'Default - Simple List',
    hint: 'Service cards with a friendly how-it-works panel',
    preview: { background: '#fff', accent: '#3B82F6', card: '#f1f5f9' },
  },
  {
    value: 'calm',
    label: 'Calm - Spa Treatment Menu',
    hint: 'Centered printed-menu look with dotted price leaders - spas, salons',
    preview: { background: '#f7f5f2', accent: '#a78b6c', card: '#eae6de' },
  },
  {
    value: 'professional',
    label: 'Professional - Clinic Directory',
    hint: 'Trust badges, department filter and a table of services - clinics, offices',
    preview: { background: '#f8fafc', accent: '#1e3a5f', card: '#e2e8f0' },
  },
];

// Restaurant menu layouts (the Settings tab shows them as illustrated cards).
export const MENU_TEMPLATES = [
  { value: 'default', label: 'Classic' },
  { value: 'modern', label: 'Modern' },
  { value: 'elegant', label: 'Elegant' },
  { value: 'minimal', label: 'Minimal' },
  { value: 'luxury', label: 'Luxury' },
  { value: 'healthy', label: 'Healthy' },
  { value: 'casual', label: 'Casual' },
  { value: 'cafe', label: 'Café' },
  { value: 'steakhouse', label: 'Steakhouse' },
  { value: 'sushi', label: 'Sushi' },
  { value: 'bar', label: 'Bar' },
]
